import { Box, Grid, GridProps } from '@mui/material';

export const ContentGridContainer = (props: GridProps) => (
    <Box sx={{ overflow: 'hidden' }}>
        <Grid container spacing={4} {...props} />
    </Box>
);
